import React from 'react';
import { config } from '../../Config/Config';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px',
  },
};

function TemplateInformPage(props) {
  const titleStyle = {
    fontSize: '24px',
    fontWeight: 600,
    fontFamily:"Montserrat",
    ...config.theme.informPageTitle,
    textAlign: 'center',
  };
  const textStyle = {
    textAlign: 'center',
    marginTop: '10px',
    fontWeight: 200,
    fontFamily:"Montserrat",
    maxWidth: "310px",
    ...config.theme.informPageText,
  };
  const subTextStyle = {
    textAlign: 'center',
    fontWeight: 200,
    fontFamily:"Montserrat",
    ...config.theme.informPageText,
  };

  return (
    <div style={styles.container}>
      <div style={titleStyle}>{props.title}</div>
      <div style={textStyle}>{props.text}</div>
      {props.subText &&
          <div style={subTextStyle}>{props.subText}</div>
      }
    </div>
  );
}

export default TemplateInformPage;
